module.exports = __webpack_public_path__ + "img/dmp3.a6851d2f.png";